import React, { useState, useEffect } from 'react';
import { Shield, Lock, FileText, Users, Building2, AlertTriangle, Eye, Info, Mail, Phone, Calendar, Loader } from 'lucide-react';
import { getPageBySlug } from '../lib/pageService';

const GizlilikPolitikasi = () => {
  const [pageContent, setPageContent] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchPageContent = async () => {
      try {
        setIsLoading(true);
        const page = await getPageBySlug('gizlilik-politikasi');
        if (page && page.content) {
          setPageContent(page.content);
        } else {
          setError('Sayfa içeriği bulunamadı.');
        }
      } catch (err) {
        console.error('Error fetching page content:', err);
        setError('Sayfa içeriği yüklenirken bir hata oluştu.');
      } finally {
        setIsLoading(false);
      }
    };

    fetchPageContent();
  }, []);

  if (isLoading) {
    return (
      <div className="min-h-screen bg-slate-50 flex items-center justify-center">
        <div className="flex items-center gap-3">
          <Loader className="w-6 h-6 text-[#F7BA45] animate-spin" />
          <span className="text-slate-600">Sayfa yükleniyor...</span>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-slate-50">
      <div className="bg-gradient-to-b from-[#F7BA45]/20 to-slate-50 py-16">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <h1 className="text-4xl md:text-5xl font-bold text-slate-800 mb-6 text-center">
              Gizlilik Politikası
            </h1>
            <div className="bg-white rounded-2xl p-8 shadow-xl border border-slate-200">
              {pageContent ? (
                <div dangerouslySetInnerHTML={{ __html: pageContent }} />
              ) : error ? (
                <div className="text-center text-red-500">
                  <p>{error}</p>
                </div>
              ) : (
                <div className="prose prose-slate max-w-none space-y-8">
                  {/* Default content if no content is loaded */}
                  <div className="flex items-start gap-4">
                    <div className="bg-[#F7BA45]/10 p-3 rounded-lg flex-shrink-0">
                      <Shield className="w-6 h-6 text-[#F7BA45]" />
                    </div>
                    <div>
                      <p className="text-slate-600 leading-relaxed">
                        Kredipark.com olarak Kişisel verilerinizin güvenliğini azami ölçüde önemsiyoruz. Kişisel verileriniz 6698 sayılı Kişisel Verilerin Korunması Kanunu ("KVKK") kapsamında işlenmekte ve korunmaktadır.
                      </p>
                    </div>
                  </div>

                  {/* Section 1 */}
                  <div className="flex items-start gap-4">
                    <div className="bg-[#F7BA45]/10 p-3 rounded-lg flex-shrink-0">
                      <Lock className="w-6 h-6 text-[#F7BA45]" />
                    </div>
                    <div>
                      <h2 className="text-2xl font-semibold text-slate-800 mb-4">1. Kişisel Verilerinizin Ne Şekilde İşlenebileceği</h2>
                      <p className="text-slate-600 leading-relaxed">
                        6698 sayılı KVKK uyarınca, Kredipark.com ile paylaştığınız kişisel verileriniz, tamamen veya kısmen, otomatik olarak veyahut herhangi bir veri kayıt sisteminin parçası olmak kaydıyla otomatik olmayan yollarla elde edilerek, kaydedilerek, depolanarak, değiştirilerek, yeniden düzenlenerek, kısacası veriler üzerinde gerçekleştirilen her türlü işleme konu olarak tarafımızdan işlenebilecektir. KVKK kapsamında veriler üzerinde gerçekleştirilen her türlü işlem "kişisel verilerin işlenmesi" olarak kabul edilmektedir.
                      </p>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GizlilikPolitikasi;